const record = value =>
  value && typeof value === 'object' && !Array.isArray(value) ? value : {};

const text = value =>
  typeof value === 'string' && value.trim() ? value.trim() : null;

const safeHttpUrl = value => {
  const candidate = text(value);
  if (!candidate) return null;

  try {
    const url = new URL(candidate);
    return ['http:', 'https:'].includes(url.protocol) ? url.toString() : null;
  } catch {
    return null;
  }
};

export const getMetaCommentContext = conversationValue => {
  const conversation = record(conversationValue);
  const additional = record(conversation.additional_attributes);
  const context = record(additional.meta_comment_context);
  const platform = text(context.platform)?.toLowerCase();

  if (!['facebook', 'instagram'].includes(platform)) return null;
  if (!text(context.comment_id)) return null;

  return {
    id: context.id ?? null,
    platform,
    commentId: text(context.comment_id),
    sourceObjectId: text(context.source_object_id),
    sourceObjectType: text(context.source_object_type),
    parentCommentId: text(context.parent_comment_id),
    authorName: text(context.author_name),
    authorUsername: text(context.author_username),
    content: text(context.content),
    sourceUrl: safeHttpUrl(context.source_url),
    commentedAt: text(context.commented_at),
  };
};
